<template>
  <div class="email-verification">
    <div class="email-verification-title">
      {{ $t('sp.registration.email.verification.title') }}
    </div>
    <div class="email-verification-sub-title">
      {{ $t('sp.registration.email.verification.sub.title.first.line') }}
      {{ $t('sp.registration.email.verification.sub.title.second.line') }}
    </div>
    <email-verification-form
      :value="spFreelancerRegistrationEmailVerificationInfo"
      @changed="formChanged"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import EmailVerificationForm from '@/components/spFreelancerRegistration/EmailVerificationForm.vue';
import { CHANGE_SP_FREELANCER_EMAIL_VERIFICATION_INFO } from '@/store/spFreelancerRegistration/actionTypes';

export default {
  name: 'EmailVerification',
  components: {
    EmailVerificationForm,
  },
  computed: {
    ...mapGetters([
      'spFreelancerRegistrationEmailVerificationInfo',
    ]),
  },
  methods: {
    formChanged(data) {
      this.$store.dispatch(CHANGE_SP_FREELANCER_EMAIL_VERIFICATION_INFO, data);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.email-verification {
  border-radius: $radius-sm;
  background-color: $white;
  padding: rem(50) rem(80) rem(35);
  box-shadow: 0 0 rem(4) 0 rgba(14, 31, 51, 0.13);
  flex: 0.7;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.email-verification-title {
  color: $auth-text-primary;
  font-family: $font-family-medium;
  font-size: rem(20);
  font-weight: 500;
  letter-spacing: 0;
  line-height: rem(24);
  padding-bottom: rem(5);
}

.email-verification-sub-title {
  height: rem(32);
  width: rem(300);
  color: $auth-text-muted;
  font-family: $font-family-medium;
  font-size: rem(14);
  letter-spacing: 0;
  line-height: rem(16);
  text-align: center;
  padding-bottom: rem(50);
}
</style>
